// Login page Animation
export const isLoginPageAnimationEnabled = true;


// Login Page Style
export const isDefaultStyle = true; // true or false


//Images
export const logoPath = "rgcplogo.png";


//Pendo Analytics
export const pendoKey = process.env?.VUE_APP_PENDO_API_KEY;
export const studyURL = "ascent.longboat.com";
export const sponsorName = "REGENXBIO";
export const studyId = "REGX281";
export const AppType = "CN";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 10
export const passwords = [
{
        key: "pass", // key used for storing this password in cookie
        value: String(process.env?.VUE_APP_PASSWORD), // password
        toRoute: "/", // go to this route/url after successful authentication
    },
{
        key: "passRev",
        value: String(process.env?.VUE_APP_AMD1_PASSWORD),
        toRoute: "amend",
    }
];


// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    
    "de",
    "en",
    "es",
    "fc",
    "fr", 
    "hu",
    "sp",
    "it",
    "ja",
];